import { setChatImagesPending, setChatImagesSucceed, setChatImagesFailed } from './actions';
import { chatImagesStatusSelector } from '../../selectors/chatImagesStatusSelector';
import { fetchChatImages } from '../../services/fetchChatImages';
import { ERequestApiStatus } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';

/**
 * Запрос файлов по http
 */
export const getChatImages =
  (chatId: string, offset?: number): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();
    const isPending = chatImagesStatusSelector(state) === ERequestApiStatus.Pending;

    if (isPending) {
      return;
    }

    dispatch(setChatImagesPending({ chatId }));
    const chatFiles = await fetchChatImages(context, {
      parameters: {
        chatId,
        offset: offset || 0,
      },
    });

    if (chatFiles) {
      dispatch(setChatImagesSucceed({ chatId, ...chatFiles }));

      return;
    }

    dispatch(setChatImagesFailed({ chatId }));
  };
